'use client'

import { PAGE_SIZES } from '@constants'
import { Grid as Grid1 } from '@mui/material'
import { AppPageSize, AppPagination } from '@ui/components'
import { FormikValues, useFormikContext } from 'formik'

interface ListBottomFiltersProps {
  totalPages: number
}

interface IPagination {
  page: number
  perPage: number
}

export default function ListBottomFilters({ totalPages }: ListBottomFiltersProps) {
  const { setFieldValue, values, handleSubmit } = useFormikContext<FormikValues>()

  const currentPage = values.page ? Number(values.page) : 1
  const currentPerPage = values.perPage ? Number(values.perPage) : PAGE_SIZES[0]

  const handlePageChange = (page: number) => {
    setFieldValue('page', page)
    handleSubmit()
  }

  const handlePerPageChange = (perPage: number) => {
    setFieldValue('perPage', perPage)
    setFieldValue('page', 1)
    handleSubmit()
  }

  return (
    <Grid1 container alignItems="end" mt={6}>
      <Grid1 item mb={{ xs: 4, md: 0 }} xs={12} md={7} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <AppPagination count={totalPages} page={currentPage} onPageChange={handlePageChange} />
      </Grid1>

      <Grid1 item xs={12} md={5} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <AppPageSize rowsPerPageSizes={PAGE_SIZES} rowsPerPage={currentPerPage} onRowsPerPageChange={handlePerPageChange} />
      </Grid1>
    </Grid1>
  )
}
